// NPM
import { graphql } from "gatsby"
import _ from "lodash"
import * as React from "react"

// Components
import Methodology from "src/components/pages/Methodology/Methodology"
import Layout from "src/layouts/fr"

const MethodologyPageFr = ({ location, data }) => {
  const topNav = data.topNav
  const methodology = data.methodology
  const productSections = _.get(data, `product.sections`, [])
  const bottomNav = data.bottomNav
  const socialMedia = _.get(data, `socialMedia.nodes`, [])

  return (
    <Layout
      location={location}
      topNav={topNav}
      page={methodology}
      bottomNav={bottomNav}
      socialMedia={socialMedia}
    >
      <Methodology
        methodology={methodology}
        productSections={productSections}
        language="fr"
      />
    </Layout>
  )
}

export default MethodologyPageFr

export const query = graphql`
  query MethodologyPageFrQuery($id: String, $productId: String) {
    topNav: strapiTopNav(locale: { eq: "fr" }) {
      ...topNavContent
    }

    methodology: strapiMethodology(id: { eq: $id }) {
      ...methodology
    }

    product: strapiPage(id: { eq: $productId }) {
      ...pageInformation
    }

    bottomNav: strapiBottomNav(locale: { eq: "fr" }) {
      ...bottomNavContent
    }

    socialMedia: allStrapiSocialMedia(filter: { locale: { eq: "fr" } }) {
      nodes {
        ...socialMedia
      }
    }
  }
`
